import { Configuration } from '@encomply/components/dashboard-settings/dashboard-filtering-attributes-dialog.component';
import { createAction, props } from '@ngrx/store';

import { Dashboard } from '../../interface/dashboard.interface';

export enum DashboardActionType {
    DASHBAORD_SELECT = '[DASHBOARD] Select',
    GET_DASHBOARDS = '[DASHBOARD] Get Dashboards',
    SET_DASHBOARDS = '[DASHBOARD] Set Dashboards',
    SET_DASHBOARD_LOADER = '[DASHBOARD] Set Dashboard Loader',
    GET_DASHBOARD_CONFIGURATION = '[DASHBOARD] Get Dashboard Configuration',
    SET_DASHBOARD_CONFIGURATION = '[DASHBOARD] Set Dashboard Configuration',
    SAVE_DASHBOARD_CONFIGURATION = '[DASHBOARD] Save Dashboard Configuration ',
}

export const SelectDashboard = createAction(
    DashboardActionType.DASHBAORD_SELECT,
    props<{
        dashboard: Dashboard;
    }>()
);

export const GetDashboards = createAction(
    DashboardActionType.GET_DASHBOARDS,
    props<{
        noAlerts?: boolean;
    }>()
);

export const SetDashboards = createAction(
    DashboardActionType.SET_DASHBOARDS,
    props<{
        analyticDashboards: [];
        currentOrganizationId: string;
    }>()
);

export const SetDashboardLoader = createAction(
    DashboardActionType.SET_DASHBOARD_LOADER,
    props<{
        isDashboardsLoading: boolean;
    }>()
);

export const GetDashboardConfiguration = createAction(
    DashboardActionType.GET_DASHBOARD_CONFIGURATION,
    props<{
        serviceId: string;
    }>()
);

export const SetDashboardConfiguration = createAction(
    DashboardActionType.SET_DASHBOARD_CONFIGURATION,
    props<{
        configuration: Configuration;
        serviceId: string;
        organizationId: string;
    }>()
);

export const SaveDashboardConfiguration = createAction(
    DashboardActionType.SAVE_DASHBOARD_CONFIGURATION,
    props<{
        payload: any;
        actionType: 'UPDATE' | 'RESET' | 'SAVE' | 'DELETE';
    }>()
);
